import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const contractAutoConfigFields = [
  "gaming_templatetypeid",
  "gaming_templatetype",
  "gaming_templateid",
  "gaming_templategroupidentifier",
  "gaming_stakeholdersecuritygroups",
  "gaming_renewalperiod",
  "gaming_numberofdaysforcontractexpiration",
  "gaming_contractusagedescription",
  "gaming_name",
  "gaming_MsSignerId",
  "gaming_maxrenewals",
  "gaming_isparentagreement",
  "gaming_firstparty",
  "gaming_expirationtype",
  "gaming_dealownerpersonnelnumber",
  "gaming_dealownername",
  "gaming_dealowner",
  "gaming_currencypayableamount",
  "gaming_contractsubcategoryid",
  "gaming_contractsubcategory",
  "gaming_contractcurrencyid",
  "gaming_contractcategoryid",
  "gaming_contractcategory",
  "gaming_contractautomationtemplate",
  "gaming_contractautomationregion",
  "gaming_contractautoconfigid",
  "gaming_companycode",
  "gaming_autosigned",
  "gaming_apicallconfiguration",
  "gaming_additionalccdemail9",
  "gaming_additionalccdemail8",
  "gaming_additionalccdemail7",
  "gaming_dataentityid",
  "gaming_businessprocessid",
  "gaming_syscreatedby",
  "gaming_contracttooltitle",
  "gaming_ndaattachmentnotviewable",
] as const;

export const contractAutoConfigReferences: EntityReferences<EntityName.gaming_contractautoconfig> =
  {
    [EntityName.gaming_mssigner]: ["gaming_MsSignerId"],
  };

export const contractAutoConfigKey: AnyEntityField<EntityName.gaming_contractautoconfig> =
  "gaming_contractautoconfigid";
